/**
 * useListingScopeFromProps — builds a ListingScope from optional prop ids.
 *
 * A1 from listing-abstraction-opportunities.md
 *
 * Memoizes the scope so consumers only re-derive when the prop values change.
 * Precedence: buildingId > inspectionSeriesId > accountId > standalone.
 */
import { useMemo } from 'react';
export function useListingScopeFromProps({ buildingId, accountId, inspectionSeriesId }) {
    return useMemo(() => {
        if (buildingId)
            return { type: 'building', id: buildingId };
        if (inspectionSeriesId)
            return { type: 'inspectionSeries', id: inspectionSeriesId };
        if (accountId)
            return { type: 'account', id: accountId };
        return { type: 'standalone' };
    }, [buildingId, inspectionSeriesId, accountId]);
}
